import React from "react";
import SignUp from "../components/SignUp";
import Nav from "../components/Nav";
function SignUpPage() {
  return (
    <div>
      <Nav />
      <SignUp />
    </div>
  );
}

export default SignUpPage;
